<template>
    <section v-if="hasPermissions(['Building-Area Write', 'Building-Area Read', 'Building-Area Area-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all Areas within your Facility. Click "Add Area" to create a new Area. Clicking "Mass Delete" will delete the Area and all Rooms within the Area.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="areas.length && hasPermissions(['Building-Area Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>

            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'area_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Building-Area Area-Upload'])"
                />
                <button v-if="hasPermissions(['Building-Area Write'])" class="modal__buttons__item w-auto px-3" v-html="'Area Updates'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="update_modal_status()"/>
                <button v-if="hasPermissions(['Building-Area Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>

            <div v-if="hasPermissions(['Building-Area Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

         <div class="tab-content" v-show="areas.length && hasPermissions(['Building-Area Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="areas"
                                :totals="totals"
                                :search="search"
                                :checkable="true"
                                :link="child_href"
                                :historiable="true"
                                @history="history($event)"
                                @emitAction="emitAction($event)"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Area'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Area Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <UpdateModalStatus 
            :title="'Areas Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :array_options="{}"
            :ids="select_ids"
            @spliceObject="update_massive_emition($event)"
        />

        <WaitingModal/>

        <HistoryModal
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
        />

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'areas_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>
import _                    from    "underscore"
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import HelperModal          from    '@/components/HelperModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import UpdateModalStatus    from   './UpdateModalStatus'
import DeletionModal        from    '@/components/DeletionModal'
import HistoryModal         from    '@/components/HistoryModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'

import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'Area',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        UpdateModalStatus,
        HistoryModal,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        HelperModal
    },

    data(){
        return{
            notyf,
            child_href:             '/building-area/',
            title_page:             'Areas',
            content_header:         this.$store.state.headers,
            rest_api:               `areas`,
            notifications:          this.$store.state.form_notyf,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            add_btn:                'Add Area',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            areas:                  [],
            levels:                 [],
            array_options:          {},
            select_ids:             [],
            histories:              [],
            history_title:          '',
            summary:                [],
            excel_data:             [],
            totals:                 [],
            helps:                  Resources.helps
        }
    },

    methods:{

        unshift_object(new_object)
        {
            this.areas.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.areas.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.areas[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.areas[index]   
            window.$('#static-update').modal('show')
        },
        fill_data(data)
        {
            this.areas = data.areas
            this.levels = data.levels
            this.array_options = {
                building_id:    data.buildings,
                level_id:       [],
            }

            const total_sq = { 'sq_footage':
                {
                    'type': '',
                    'text': 'Sq. Footage',
                    'value': data.sq_ft,
                    'show' : true,
                },
            }

            this.totals.push(total_sq)
            this.sumSqFootage()
        },

        

        trashing(index)
        {
            this.areas.splice(index, 1)
        },

        update_modal_status()
        {
            this.select_ids = this.areas.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-update-status').modal('show')
            }
        },

        update_massive_emition(data)
        {
            this.select_ids.forEach( item =>
            {
                const index = this.areas.findIndex(value => value.id == item)
                if(index > -1)
                {
                    this.areas[index].closed = data.closed 
                }
            })
            this.select_ids = []
        },

       async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }
            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
            this.loader()
            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories
                if(this.histories.length === 0)
                {
                    return this.notyf.error('Empty History')
                }
                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }
        },

        emitAction(data)
        {
            if(data.header == 'room_counter_record')
            {
                const area_id = this.$refs.dinamic_table.display_items[data.index].origin_id || null;
                const level_id = this.$refs.dinamic_table.display_items[data.index].level_id || null;
                const building_id = this.$refs.dinamic_table.display_items[data.index].building_id || null;
                this.$router.push(`/building-rooms?building_id=${building_id}&level_id=${level_id}&area_id=${area_id}`)
            }
        },

        massive_modal_delete()
        {
            this.select_ids = this.areas.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.areas.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.areas.splice(index, 1)
                    }
                })
                this.select_ids = []
            }

            this.sumSqFootage()
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {

                const entity = {}
                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const building = this.array_options.building_id.find(item => item.name == entity.building_id)
                entity.building_id = building ? building.id : undefined

                let level = null

                if(building)
                {
                    level = this.levels.find(item => item.name == entity.level_id && item.building_id == building.id)
                }

                entity.level_id = level ? level.id : null

                send_data.push(entity)
            }

           
            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { areas: send_data })
            this.loader()
            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                for (const area of response.data.areas) {
                    this.unshift_object(area);
                }
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },
        
        async sumSqFootage (list_to_sum)
        {
            list_to_sum = (!list_to_sum) ? this.areas : list_to_sum

            let sum = 0;
            list_to_sum.forEach(x=>
            {
                const sqFootage = parseFloat(x.sq_footage.replace(/,/g, ''));

                if (!isNaN(sqFootage) && sqFootage > 0) {
                    sum += sqFootage;
                }
                
            })
            
            const formattedSum = sum.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })

            this.totals[0].sq_footage.value = formattedSum

        },

    },

    async mounted(){
        if(this.hasPermissions(['Building-Area Write', 'Building-Area Read', 'Building-Area Area-Upload']))
        {
            await this.api_request()
        }
    },

    watch:{
        search(val) 
        {
             let filters_items = [];
            if(this.search)
            {
                this.table_headers.forEach(header =>
                { 

                    filters_items.push( ... this.areas.filter(item =>
                    {
                        return String(item[header.value]).toLowerCase().includes(val.toLowerCase())
                    }))
                });
                const unique_values =  this.search ? _.uniq(filters_items, item => item.id ) : this.items; 

                this.sumSqFootage(unique_values)
            }
            else
            {
                this.sumSqFootage()

            }

        }

    },

    computed:
    {
        selected()
        {
            const bool = this.areas.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
    
}

</script>